import { STRINGS } from 'config';
import { useRef } from 'react';
import { getWallet } from 'store/action/wallet';
import { useAppDispatch, useAppState } from 'store/configureStore';

interface UseWebSocket {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  connect: (url: URL, onMessage: (data: any) => void, onError: () => void, onClose?: () => void) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  send: (message: any) => void;
  closeConnection: () => void;
}

const {
  REDUCERS: {
    WEBSOCKET: { CONNECTION_OPEN, CONNECTION_FAILED, CONNECTION_CLOSE },
  },
} = STRINGS;

export const useWebSocket = (): UseWebSocket => {
  const dispatch = useAppDispatch();
  const { selectedPractice } = useAppState().app;
  const socketRef = useRef<WebSocket | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const connect = async (url: URL, onMessage: (data: any) => void, onError: () => void, onClose?: () => void) => {
    socketRef.current = new WebSocket(url);
    dispatch({
      type: CONNECTION_OPEN,
    });

    socketRef.current.onmessage = event => {
      const data = JSON.parse(event.data);
      onMessage(data);
    };

    socketRef.current.onerror = error => {
      dispatch({
        type: CONNECTION_FAILED,
        payload: error,
      });
      onError();
    };
    socketRef.current.onclose = async () => {
      dispatch({
        type: CONNECTION_CLOSE,
      });
      if (onClose) {
        onClose();
      }
      if (selectedPractice?.id) {
        await getWallet(dispatch, selectedPractice.id);
      }
    };
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const send = (message: any) => {
    if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
      socketRef.current.send(message);
    }
  };

  const closeConnection = () => {
    if (socketRef.current) {
      socketRef.current.close();
    }
  };

  return { connect, send, closeConnection };
};
